module.exports = __webpack_public_path__ + "img/photo_230620702_2.803c8bf2.jpg";